import React, { useEffect } from "react";

export default function Assignments() {
    useEffect(()=> {
        document.title = "Techlogics | Assignments";
    })
    return <div>Assignments</div>;
}
